/* src/app/master-data/activity-type/list-activity-type/list-activity-type.component.css */
/*# sourceMappingURL=list-activity-type.component-XGGSRDXP.css.map */
